import { render, staticRenderFns } from "./MaterialSelection.vue?vue&type=template&id=19cf268a&scoped=true"
import script from "./MaterialSelection.vue?vue&type=script&lang=js"
export * from "./MaterialSelection.vue?vue&type=script&lang=js"
import style0 from "./MaterialSelection.vue?vue&type=style&index=0&id=19cf268a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cf268a",
  null
  
)

export default component.exports